<script lang="ts" setup>
// Properties
const props = defineProps({});

// Data
</script>

<template>
    <label class="mb-1 block text-sm font-semibold text-gray-600">
        <slot></slot>
    </label>
</template>

<style scoped></style>
